export var OWNER_TYPE;
(function (OWNER_TYPE) {
    OWNER_TYPE["SELF_OWNED"] = "self_owned";
    OWNER_TYPE["NATURAL_PERSON"] = "natural_person";
    OWNER_TYPE["LEGAL_ENTITY"] = "legal_entity";
})(OWNER_TYPE || (OWNER_TYPE = {}));
export var WALLET_TYPE;
(function (WALLET_TYPE) {
    WALLET_TYPE["SELF_HOSTED"] = "self_hosted";
    WALLET_TYPE["VASP_HOSTED"] = "vasp_hosted";
})(WALLET_TYPE || (WALLET_TYPE = {}));
